import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { getTotalRemaining } from '../../helpers/deals';
import BasketDealProduct from './BasketDealProduct';

export default function BasketDeal({
  bt,
  isAuthenticated,
  giftWrap,
  deal,
  isRedeemPostage,
}) {
  const products = deal.products || [];

  const quantityArray = products.map((item) => item.quantity);
  const selectedOptionsSum = quantityArray.reduce((a, b) => a + b, 0);

  const totalRemainingForDay = getTotalRemaining(deal);
  const [remainingQuantity, setRemainingQuantity] =
    useState(totalRemainingForDay);

  useEffect(() => {
    if (remainingQuantity !== null && remainingQuantity >= 0) {
      setRemainingQuantity(totalRemainingForDay - selectedOptionsSum);
    }
  }, [remainingQuantity, totalRemainingForDay, selectedOptionsSum]);

  return (
    <>
      {products.map((product) => {
        return (
          <BasketDealProduct
            bt={bt}
            calendarDeal={
              deal.productDisplay && deal.productDisplay.type === 'calendar'
            }
            deal={deal}
            giftWrap={giftWrap}
            isAuthenticated={isAuthenticated}
            isRedeemPostage={isRedeemPostage}
            key={product.id}
            product={product}
            remainingQuantity={remainingQuantity}
            socialCue={product?.socialCueClaim}
          />
        );
      })}
    </>
  );
}

BasketDeal.propTypes = {
  bt: PropTypes.string,
  deal: PropTypes.object,
  giftWrap: PropTypes.object,
  isAuthenticated: PropTypes.bool,
  isRedeemPostage: PropTypes.bool,
};
